import Store from "@/store/index.js";
import axios from 'axios';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

const domain = Store.state.domain;

export default {
    async ObtenerFechas(uslogin) {
        let formData = new FormData();
        formData.append("uslogin", uslogin);
        let response = await axios.post(`${domain.domainNameForApi}Vacaciones/ObtenerFechas`, formData);
        return response.data[0];
    },
    async ObtenerDiasVacaciones(uslogin) {
        let formData = new FormData();
        formData.append("uslogin", uslogin);
        let response = await axios.post(`${domain.domainNameForApi}Vacaciones/ObtenerDiasVacaciones`, formData);
        return response.data[0];
    },
    async GuardarSolicitud(vacid, diassolicitados, uslogin) {
        var formData = new FormData();
        formData.append("vacid", vacid);
        formData.append("diassolicitados", diassolicitados);
        formData.append("uslogin", uslogin);
        let response = await axios.post(`${domain.domainNameForApi}Vacaciones/GuardarSolicitud`, formData);
        return response.data;
    },
    async ActualizaNumeroDePeriodos(uslogin) {
        let formData = new FormData();
        formData.append("uslogin", uslogin);
        let response = await axios.post(`${domain.domainNameForApi}Vacaciones/ActualizaNumeroDePeriodos`, formData);
        return response.data;
    },
    async ResponderSolicitud(vaeid, vadid, status, usloginSolicitante) {
        var formData = new FormData();
        formData.append("vaeid", vaeid);
        formData.append("status", status);
        formData.append("vadid", vadid);
        formData.append("uslogin", usloginSolicitante);
        let response = await axios.post(`${domain.domainNameForApi}Vacaciones/ResponderSolicitud`, formData);
        return response.data;
    },

    async ObtenerDiasDeOtrosUsuarios(showTodo) {
        let formData = new FormData();
        formData.append("uslogin", MetodosGenerales.ObtenerUserName());
        formData.append("showTodo", showTodo);
        let response = await axios.post(`${domain.domainNameForApi}Vacaciones/ObtenerDiasDeOtrosUsuarios`, formData);
        return response.data;
    }
}